export enum UtmMedium {
  Jooble = 'jooble',
}
